import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { Store } from "@ngxs/store";

import { UiActions } from '@store/actions/ui.actions';

/** Set to true to skip the global 403 forbidden handling for a specific request */
export const SKIP_403_HANDLING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class BffForbiddenInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 403) {
          if (request.context.get(SKIP_403_HANDLING)) {
            return throwError(() => err);
          }
          this.store.dispatch(new UiActions.setForbidden403Access());
          return EMPTY;
        }
        return throwError(() => err);
      }),
    );
  }
}
